import { Component, OnInit, Input, Inject, EventEmitter, Output, ElementRef } from '@angular/core';
import { AppStartupService } from '@ridango/core';
import { BaseTicketComponent } from '../base-ticket/base-ticket.component';

@Component( {
    selector: 'ridango-wallet-ticket',
    templateUrl: './wallet-ticket.component.html'
} )
export class WalletTicketComponent extends BaseTicketComponent implements OnInit {

    constructor( @Inject( 'ENV' ) public env: any, public eRef: ElementRef, public appStartUpService: AppStartupService ) {
        super( env, eRef, appStartUpService );
    }

}
